import React, { PropTypes } from 'react';
import Icon from 'common/components/svg_icon';
import classNames from 'classnames';
import { isCollaborator } from 'project/utils';

/**
 * Project feedback icon.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const ProjectFeedback = (
  { project, user, iconSize='xl', showLabel=false, showClientFeedback=false
}) => {

  /* if no project is specified or entry count is not high enough, show no feedback icon */
  if (!project || project.entry_count < 3) {
    return (
      <div className="project-feedback">
        <span className="stat-value">–</span>
      </div>);
  }

  /* `client_feedback` range is (0, 100) instead of (0, 5) */
  const score = (project.client_feedback / 20);

  let feedback = 'bad';
  let label = 'Poor';

  if (score >= 3.5) {
    feedback = 'good';
    label = 'Good';
  }
  else if (score >= 2.5) {
    feedback = 'meh';
    label = 'Okay';
  }

  const iconClasses = classNames('svg-icon', `svg-icon-${iconSize}`, `feedback-${feedback}`);

  return (
    <div className="project-feedback">
      <Icon className={iconClasses} icon={`feedback-${feedback}`}/>
      { showLabel && <span className="feedback-label">{ label }</span>}
    </div>)
}

/**
 * PropTypes.
 *
 * @property {object} project
 * @property {string} iconSize - icon size ('xl', etc)
 * @property {bool} showLabel - whether to show associated feedback label
 * @property {bool} showClientFeedback - whether to show client feedback independently of logged in user
 *
 */
ProjectFeedback.propTypes = {
  project: PropTypes.object,
  iconSize: PropTypes.string,
  showLabel: PropTypes.bool,
  showClientFeedback: PropTypes.bool,
};

export default ProjectFeedback;



// WEBPACK FOOTER //
// ./common/components/project_feedback.jsx